module.exports = __webpack_public_path__ + "img/icon_add@2x.a5cee1ed.png";